// Presentation Layer - Banner de instalación PWA
import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { Button, Text, Surface, IconButton } from 'react-native-paper';
import { usePWA } from '../hooks/usePWA';

export const PWAInstallBanner: React.FC = () => {
  const { canInstall, install } = usePWA();
  const [dismissed, setDismissed] = React.useState(false);

  if (Platform.OS !== 'web' || !canInstall || dismissed) {
    return null;
  }

  const handleInstall = async () => {
    const success = await install();
    if (success) {
      setDismissed(true);
    }
  };

  return (
    <Surface style={styles.container} elevation={2}>
      <View style={styles.content}>
        <View style={styles.textContainer}>
          <Text variant="titleSmall" style={styles.title}>
            Instalar aplicación
          </Text>
          <Text variant="bodySmall" style={styles.description}>
            Instala Care Badge Scanner para acceso rápido y uso sin conexión
          </Text>
        </View>
        <View style={styles.actions}>
          <Button mode="contained" onPress={handleInstall} compact>
            Instalar
          </Button>
          <IconButton
            icon="close"
            size={20}
            onPress={() => setDismissed(true)}
          />
        </View>
      </View>
    </Surface>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute' as any,
    bottom: 16,
    left: 16,
    right: 16,
    borderRadius: 8,
    zIndex: 1000,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    gap: 12,
  },
  textContainer: {
    flex: 1,
  },
  title: {
    fontWeight: '600',
    marginBottom: 4,
  },
  description: {
    opacity: 0.7,
  },
  actions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
});
